import { UserModule } from './user/index';
import { BulkModule } from './bulk/index';
import { ChallengeModule } from './challenge/index';
import { LayoutModule } from './layout/index';
import { JsonClient } from '@/util/JsonClient';
import { ListModule } from './licenselist';

export * from './actions';
export * from './types';

import { createStore } from 'vuex';
import { EmptyChallengeState, EmptyUserState, RootState } from './types';
import { EmptyBulkState } from './bulk/types';
import { EmptyLayoutRevisionState } from './layout/types';
import { EmptyLicenseListState } from './licenselist/types';

const backend = new JsonClient();

export default createStore({
    modules: {
        user: new UserModule(backend),
        challenge: new ChallengeModule(backend),
        bulk: new BulkModule(backend),
        layout: new LayoutModule(backend),
        list: new ListModule(backend),
    },
});

export function EmptyStoreState() {
    return {
        version: '',
        user: EmptyUserState(),
        challenge: EmptyChallengeState(),
        bulk: EmptyBulkState(),
        layout: EmptyLayoutRevisionState(),
        licenselist: EmptyLicenseListState(),
    } as RootState;
}


